module.exports = __webpack_public_path__ + "img/Cursed Village Annotated.5f8fcb2e.jpg";